export const engagementCampaignsTagsWithIds = "/engagement/campaigns/tags_with_ids";
